export default function({ route, redirect, store }) {
  if (route.name === 'public-formatos-uuid' && store.$auth.loggedIn) {
    // console.warn('MIDDLEWARE ROUTE ', route.name);
    store.$auth.logout()
  }
}
